const STORAGE_DURATIONS = [
  { value: "7", label: "7 Days" },
  { value: "30", label: "30 Days" },
  { value: "60", label: "60 Days" },
  { value: "90", label: "90 Days" },
  { value: "365", label: "365 Days" },
  { value: "731", label: "2 Years" },
  { value: "1096", label: "3 Years" },
  { value: "1461", label: "4 Years" },
  { value: "1826", label: "5 Years" },
];

angular
.module('app.views')
.controller('AccountFormController', function($scope, $location, $routeParams, $modalInstance, $filter, Account, Config, Reseller, User, FeatureBillingService, Manufacturer, AccountSubscriptions){
  $scope.config = Config;

  $scope.isSaving = false;
  let now = new Date();
  let expiry = new Date(new Date().getTime() + (42*86400000)); // 6 weeks from now

  $scope.storageDurations = _.clone(STORAGE_DURATIONS);

  function randomPassword(len) {
    let alphabet, i, jumble;
    alphabet = '23456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghikmnpqrstuvwxyz';
    jumble = (() => {
      let j, ref, results;
      results = [];
      for (i = j = 1, ref = len; 1 <= ref ? j <= ref : j >= ref; i = 1 <= ref ? ++j : --j) {
        results.push(alphabet.substr(Math.floor(Math.random() * alphabet.length), 1));
      }
      return results;
    })();
    return jumble.join('');
  };

  // new account defaults
  $scope.tags = [];
  $scope.toggleTag = function(tag){
    hasTag(tag) ? removeTag(tag) : addTag(tag);
  };
  $scope.flags = {
    showAdvancedConfig: false,
    streamQuality: null,
  };
  $scope.usageFlags = [];
  $scope.toggleUsageFlag = function(usageFlag){
    hasUsageFlag(usageFlag) ? removeUsageFlag(usageFlag) : addUsageFlag(usageFlag);
  };
  $scope.extraFeatures = [];
  $scope.toggleExtraFeature = function(extraFeature){
    hasExtraFeature(extraFeature) ? removeExtraFeature(extraFeature) : addExtraFeature(extraFeature);
  };
  $scope.behaviorModifications = [];
  $scope.toggleBehaviorModification = function(behaviorModification){
    hasBehaviorModification(behaviorModification) ? removeBehaviorModification(behaviorModification) : addBehaviorModification(behaviorModification);
  };

  $scope.resellers = Reseller.query({l: 1000});

  $scope.isNew = !$routeParams.id;
  if ($scope.isNew) {
    // Defaults for new account
    $scope.account = {
      expires_on: `${expiry.getMonth()+1}/${expiry.getDate()}/${expiry.getFullYear()}`,
      time_zone: 'Eastern Time (US & Canada)',
      status: 'initial',
      payment_status: 'info_requested',
      ticket_revenue_share: '75',
      sale_closed_on: `${now.getMonth()+1}/${now.getDate()}/${now.getFullYear()}`,
      metadata: {},
      reseller: '',
    };
    $scope.newUser = {
      enabled: true,
      sendVerification: true,
      sendPayment: true,
      user: {}
    };
    $scope.newManufacturer = {
      doCreate: false,
      manufacturer: {}
    }
  } else {
    $scope.account = Account.get({id: $routeParams.id}, (data) => {
      tagsFromString(data.tags, data.resolution_limit);
      $scope.usageFlags = data.usage_flags ? data.usage_flags.split(' ') : [];
      $scope.extraFeatures = data.extra_features ? data.extra_features.split(' ') : [];
      $scope.behaviorModifications = data.behavior_modifications ? data.behavior_modifications.split(' ') : [];
      if (!data.storage_policy) {
        $scope.storageDurations.unshift({value: "0", label: "No expiration"});
        $scope.accountNeedsAStoragePolicy = true;
      }
    });

    $scope.account.$promise.then(() => {
      if ($scope.account.stripe_customer_handle) {
        $scope.subscriptions = AccountSubscriptions.get({account_id: $routeParams.id});
        $scope.subscriptions.$promise.then(() => {
          $scope.featureSummary = FeatureBillingService.featureSummary($scope.account, $scope.subscriptions.features);
          $scope.flags.showAdvancedConfig = ($scope.featureSummary.extraFlags.length || $scope.featureSummary.missingFlags.length);
        });
      } else {
        $scope.flags.showAdvancedConfig = true;
      }
      if (!$scope.account.metadata) {
        $scope.account.metadata = {};
      }
    });
  }

  $scope.isExtraTag = (tag) => {
    if (!$scope.featureSummary) return undefined;
    return $scope.featureSummary.extraFlags.find((obj) => obj.value == tag);
  };

  $scope.isMissingTag = (tag) => {
    if (!$scope.featureSummary) return undefined;
    return $scope.featureSummary.missingFlags.find((obj) => obj.value == tag);
  };


  function hasTag(tag) {
    return $scope.tags.indexOf(tag) >= 0;
  }
  function addTag(tag) {
    $scope.tags.push(tag);
  }
  function removeTag(tag) {
    $scope.tags = FeatureBillingService.removeTag($scope.tags, tag);
  }

  $scope.specialTagsToSkip = ['low_cost_plan'];

  function tagsFromString(tagStr, resolutionLimit) {
    // turn space-delimited string into array
    $scope.tags = `${tagStr}` === '' ? [] : tagStr.split(' ');

    // also extract/stash a few separate fields directly onto scope
    if (resolutionLimit == 480) {
      $scope.flags.streamQuality = 'sd';
    } else if (hasTag('low_cost_plan')) {
      removeTag('low_cost_plan');
      $scope.flags.streamQuality = 'low_cost';
    } else if (resolutionLimit == 720) {
      $scope.flags.streamQuality = '720';
    } else if (resolutionLimit == 1080) {
      $scope.flags.streamQuality = 'hd';
    } else {
      $scope.flags.streamQuality = '4k';
    }
  }

  function tagsToString() {
    // array to string
    // also re-encode the separately-managed fields from scope
    switch ($scope.flags.streamQuality) {
    case 'sd':
      $scope.account.resolution_limit = 480;
      break;
    case 'low_cost':
      $scope.account.resolution_limit = 720;
      addTag('low_cost_plan');
      break;
    case '720':
      $scope.account.resolution_limit = 720;
      break;
    case 'hd':
      $scope.account.resolution_limit = 1080;
      break;
    case '4k':
      $scope.account.resolution_limit = 2160;
      break;
    default:
      throw new Error('Streaming quality is required');
    }
    return $scope.tags.sort().join(' ');
  }

  function hasUsageFlag(usageFlag) {
    return $scope.usageFlags.indexOf(usageFlag) >= 0;
  }
  function addUsageFlag(usageFlag) {
    $scope.usageFlags.push(usageFlag);
  }
  function removeUsageFlag(usageFlag) {
    const idx = $scope.usageFlags.indexOf(usageFlag);
    if (idx >= 0) {
      $scope.usageFlags.splice(idx, 1);
    }
  }

  function hasExtraFeature(extraFeature) {
    return $scope.extraFeatures.indexOf(extraFeature) >= 0;
  }
  function addExtraFeature(extraFeature) {
    $scope.extraFeatures.push(extraFeature);
  }
  function removeExtraFeature(extraFeature) {
    const idx = $scope.extraFeatures.indexOf(extraFeature);
    if (idx >= 0) {
      $scope.extraFeatures.splice(idx, 1);
    }
  }

  function hasBehaviorModification(behaviorModification) {
    return $scope.behaviorModifications.indexOf(behaviorModification) >= 0;
  }
  function addBehaviorModification(behaviorModification) {
    $scope.behaviorModifications.push(behaviorModification);
  }
  function removeBehaviorModification(behaviorModification) {
    const idx = $scope.behaviorModifications.indexOf(behaviorModification);
    if (idx >= 0) {
      $scope.behaviorModifications.splice(idx, 1);
    }
  }

  $scope.ok = function() {
    let account;

    if ($scope.account.storage_policy && !$scope.account.storage_duration_days) {
      alert("Please select a storage duration.");
      return;
    }
    if (!$scope.account.storage_policy) {
      $scope.account.storage_duration_days = '0';
    }

    $scope.account.tags = tagsToString();
    $scope.account.usage_flags = $scope.usageFlags.sort().join(' ');
    $scope.account.extra_features = $scope.extraFeatures.sort().join(' ');
    $scope.account.behavior_modifications = $scope.behaviorModifications.sort().join(' ');

    if (!$scope.account.metadata.show_sunday_streams_import) {
      delete $scope.account.metadata.show_sunday_streams_import;
    }

    $scope.isSaving = true;

    expiry = new Date($scope.account.expires_on);
    if (expiry.getTime() > 0) {
      $scope.account.expires_on = expiry.toISOString().substr(0, 10);
    }
    const sale_closed_on = new Date($scope.account.sale_closed_on);
    if (sale_closed_on.getTime() > 0) {
      $scope.account.sale_closed_on = sale_closed_on.toISOString().substr(0, 10);
    }

    if (!$scope.account.payment_status) {
      delete $scope.account.payment_status;
    }

    if ($scope.isNew) {
      // Force lowercase e-mail for dupe checking
      $scope.newUser.user.email = $filter('lowercase')($scope.newUser.user.email);
      $scope.newManufacturer.manufacturer.name = $scope.account.name;

      // New account wizard artifically separates name to enforce consistency
      account = angular.copy($scope.account);
      if (account.city_state) {
        account.name = `${account.name.trim()} - ${account.city_state.trim()}`;
      }
      delete account.city_state;
      const promise1 = Account.save(account).$promise;
      const promise2 = promise1.then(function(a){
        if ($scope.newManufacturer.doCreate) {
          const m = angular.copy($scope.newManufacturer.manufacturer);
          const generatedPassword = randomPassword(16);
          m.account_id = a.id; 
          m.password = generatedPassword;  
          return Manufacturer.save(m,
            m => {
              // download a yaml file with credentials to be used in the manufacturing process
              const ymlStr = `---\nuser: ${m.id}\npassword: ${generatedPassword}`;
              const downloadAnchorNode = document.createElement('a');
              downloadAnchorNode.setAttribute("href", `data:text;charset=utf-8,${encodeURIComponent(ymlStr)}`);
              downloadAnchorNode.setAttribute("download", "creds.yml");
              downloadAnchorNode.click();
              downloadAnchorNode.remove();
            },
            function(err){
              alert('Error creating manufacturer')
          }).$promise;
        }
      });
      return Promise.all([promise1, promise2]).then(function([a, m]){
        // create initial user (and send emails) if necessary before closing modal
        if ($scope.newUser.enabled) {
          const u = angular.copy($scope.newUser.user);
          u.account_id = a.id;
          u.name = u.email; //shortcut
          u.roles = ['standard-user'];
          if ($scope.newUser.sendVerification) {
            u.requires_verification = true;
          }
          if ($scope.newUser.sendPayment) {
            u.request_payment_email = true;
          }
          return User.save(u,
            u=> $modalInstance.close(a),
            function(err){
              // account was created but first user was not
              alert('You will now be taken to the new account page. Please create the user again there.');
              return $modalInstance.close(a);
          });
        } else {
          return $modalInstance.close(a);
        }
      });
    } else {
      const promise = Account.update($scope.account).$promise;
      return promise.then(a => {
        return $modalInstance.close(a);
      }).catch((err) => {
        $scope.isSaving = false;
      });
    }
  };

  return $scope.cancel = () => $modalInstance.dismiss('cancel');
});



// WEBPACK FOOTER //
// ./views/account/account_form_controller.js